import { action } from 'satcheljs/lib/legacy';
import { MeetingRequestViewState } from '../store/schema/MeetingRequestViewState';

export default action('toggleShowHideConflicts')(function toggleShowHideConflicts(
    viewState: MeetingRequestViewState
) {
    viewState.conflictsShown = !viewState.conflictsShown;
});
